// =============================================================================
// MONEY FORMATTING - one helper, and it always takes a currency
// =============================================================================
// There were two ways to render money in this app: Dashboard's formatCurrency,
// which defaulted to EUR, and a hardcoded '€' glued onto the Billing page's
// numbers. The second one printed 119€ while Shopify charged $119, because the
// price is an amount in OUR billing currency and the sign was decoration.
//
// Two different things are called "currency" in this product and they must not
// be mixed:
//   - the currency WE bill in (one value, comes from /billing/plans)
//   - the currency the MERCHANT sells in (theirs, comes with their revenue)
// Both go through this function, and both must pass their own currency in.
// There is no default on purpose: a default is how one of them silently became
// the other.

export function formatMoney(amount: number, currency: string, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    // fr-FR renders USD as "$US" by default to distinguish it from the
    // Canadian dollar; the narrow symbol keeps "29 $" in French and "$29" in
    // English, which is what both merchants expect to read.
    currencyDisplay: 'narrowSymbol',
    // Whole prices read as "$119", not "$119.00"; anything with cents keeps them.
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
